import styled from 'styled-components'

import { theme } from '@/theme'

export const NumberCircle = styled.div`
  border-radius: 50%;
  width: ${theme.spacing.mediumLarge};
  height: ${theme.spacing.mediumLarge};
  font-size: ${theme.fontSizes.speak};
  line-height: ${theme.lineHeights.speak};
  background-color: ${theme.colors.black};
  color: ${theme.colors.white};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: ${theme.spacing.small};
`
export default NumberCircle
